var AdaptiveImage = require( "../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/img_webpush_70x70.23f9f51f.png","uri@2x": __webpack_public_path__ + "static/media/img_webpush_70x70.d86466fa.png","uri@3x": __webpack_public_path__ + "static/media/img_webpush_70x70.0ba325f0.png",
    width: 70,
    height: 70
});